const ClassName = {
	FILLED: '_filled',
};

class Input {
	constructor(input) {
		this.init(input);
	}

	init(container) {
		this.container = container;

		if (!this.container) {
			return;
		}

		this.input = this.container.querySelector('.input__input');
		this.resetButton = this.container.querySelector('.input__reset-btn');
		this.placeholder = this.container.querySelector('.input__placeholder');

		this._onInputInput = this._onInputInput.bind(this);
		this._onResetButtonClick = this._onResetButtonClick.bind(this);

		this.input.addEventListener('input', this._onInputInput);
		this.resetButton &&
			this.resetButton.addEventListener('click', this._onResetButtonClick);
	}
	_onInputInput(evt) {
		const input = evt.currentTarget;

		if (input.value) {
			this.container.classList.add(ClassName.FILLED);
		} else {
			this.container.classList.remove(ClassName.FILLED);
		}
	}
	_onResetButtonClick(evt) {
		evt.preventDefault();

		this.placeholder.style = 'block';
		this.reset();
	}
	reset() {
		this.input.value = '';
		this.container.classList.remove(ClassName.FILLED);
	}
}

export default Input;
